import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["username", "available", "unvailable"]
  static values = { url: String }

  checkAvailability() {
    const value = this.usernameTarget.value;
    const url = this.urlValue;
    fetch(`${url}?nick=${value}`)
      .then((response) => response.json())
      .then(data => {
        if (data.available) {
          this.unvailableTarget.setAttribute("hidden", true)
          this.availableTarget.removeAttribute("hidden")
        } else {
          this.availableTarget.setAttribute("hidden", true)
          this.unvailableTarget.removeAttribute("hidden")
        }
      })
  }

}
